import React from "react";

import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";

import SubNavigation from "../../components/subNavigation/subNavigation";
import SubNavPoint from "../../components/subNavPoint/subNavPoint";
import getInternalLinkById from "../../utils/getInternalLinkById";
import getSitePages from "../../utils/getSitePages";

const SubNavigationGenerator = ({ id }) => {
  const data = useStaticQuery(graphql`
    {
      primaryNavigation: kontentItemNavigationItem(system: {codename: {eq: "primary_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              preferred_language
              ... on kontent_item_navigation_item {
                id,
                elements {
                  title {
                    value
                  }
                  url_slug {
                    value
                  }
                  external_url {
                    value
                  }
                  elements {
                    value {
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          url_slug {
                            value
                          }
                          external_url {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      secondaryNavigation: kontentItemNavigationItem(system: {codename: {eq: "secondary_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              preferred_language
              ... on kontent_item_navigation_item {
                id,
                elements {
                  title {
                    value
                  }
                  url_slug {
                    value
                  }
                  external_url {
                    value
                  }
                  elements {
                    value {
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          url_slug {
                            value
                          }
                          external_url {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  if (id) {
    const node = getInternalLinkById(id);
    const sitePages = getSitePages();

    if (node) {
      const slugParts = node.slug.split("/");
      // Remove first empty element
      slugParts.shift();

      const items = [];

      if (slugParts.length > 0 && slugParts[0]) {
        const navigationData = data.primaryNavigation.elements.elements.value.concat(
          data.secondaryNavigation.elements.elements.value,
        );

        const mainItem = sitePages.links.nodes.find((el) => el.slug === `/${slugParts[0]}`);

        if (mainItem) {
          const mainNavigation = navigationData.find(
            (el) => el.id === mainItem.nodeId || el.id === mainItem.parentId,
          );

          if (mainNavigation) {
            mainNavigation.elements.elements.value.forEach((item) => {
              if (!item.id) return null;

              items.push(
                <SubNavPoint
                  {...item}
                  href={item.id}
                  key={item.id}
                  color="black"
                  className={item.className}
                >
                  {item.elements.title.value}
                </SubNavPoint>,
              );

              return null;
            });
          }

          if (items.length > 0) {
            return <SubNavigation items={items} />;
          }
        }
      }
    }
  }

  return null;
};

SubNavigationGenerator.propTypes = {
  id: PropTypes.string.isRequired,
};

export default SubNavigationGenerator;
